import { clearDivWrapper } from "../../datatypeComponents/NarrativeEntry";

const generateM11Narrative = (compositionResource) => {
    let divText = "";
    if (compositionResource?.section?.length > 0) {
        for (const section of compositionResource.section) {
            divText += "<h1>" + (section.title || section.code?.coding?.[0]?.display || section.code?.text || "Untitled Section") + "</h1>";
            if (section.text?.div && section.text.status !== "empty") {
                divText += "<div>" + clearDivWrapper(section.text.div) + "</div>";
            }
            if (section.section?.length > 0) {
                for (const subsection of section.section) {
                    divText += "<h2>" + (subsection.title || subsection.code?.coding?.[0]?.display || subsection.code?.text || "Untitled Section") + "</h2>";
                    if (subsection.text?.div && subsection.text.status !== "empty") {
                        divText += "<div>" + clearDivWrapper(subsection.text.div) + "</div>";
                    }
                    if (subsection.section?.length > 0) {
                        for (const sub2section of subsection.section) {
                            divText += "<h3>" + (sub2section.title || sub2section.code?.coding?.[0]?.display || sub2section.code?.text || "Untitled Section") + "</h3>";
                            if (sub2section.text?.div && sub2section.text.status !== "empty") {
                                divText += "<div>" + clearDivWrapper(sub2section.text.div) + "</div>";
                            }
                            if (sub2section.section?.length > 0) {
                                for (const sub3section of sub2section.section) {
                                    divText += "<h4>" + (sub3section.title || sub3section.code?.coding?.[0]?.display || sub3section.code?.text || "Untitled Section") + "</h4>";
                                    if (sub3section.text?.div && sub3section.text.status !== "empty") {
                                        divText += "<div>" + clearDivWrapper(sub3section.text.div) + "</div>";
                                    }
                                    if (sub3section.section?.length > 0) {
                                        for (const sub4section of sub3section.section) {
                                            divText += "<h5>" + (sub4section.title || sub4section.code?.coding?.[0]?.display || sub4section.code?.text || "Untitled Section") + "</h5>";
                                            if (sub4section.text?.div && sub4section.text.status !== "empty") {
                                                divText += "<div>" + clearDivWrapper(sub4section.text.div) + "</div>";
                                            }
                                            if (sub4section.section?.length > 0) {
                                                for (const sub5section of sub4section.section) {
                                                    divText += "<h5>" + (sub5section.title || sub5section.code?.coding?.[0]?.display || sub5section.code?.text || "Untitled Section") + "</h5>";
                                                    if (sub5section.text?.div && sub5section.text.status !== "empty") {
                                                        divText += "<div>" + clearDivWrapper(sub5section.text.div) + "</div>";
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    let generatedNarrative = {
        "status": "empty",
        "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
    };
    if (divText) {
        generatedNarrative = {
            "status": "generated",
            "div": '<div xmlns="http://www.w3.org/1999/xhtml">' + divText + '</div>'
        };
    }
    return generatedNarrative;
};

export default generateM11Narrative;